/* eslint-disable @typescript-eslint/no-explicit-any */
import { createElement, version } from 'react';
import * as ReactDOM from 'react-dom';
import { PlaceholderElement, PropsData } from './mf-utils.js';
export function createReactMicrofrontend(component) {
    if (version.startsWith('17')) {
        return createReact17Microfrontend(component);
    }
    let root;
    return {
        async mount(props, container) {
            // @ts-expect-error - React 17 and 18 have different exports
            root = ReactDOM.createRoot(container);
            root.render(createElement(component, { ...props }));
        },
        async unmount() {
            if (!root) {
                throw new Error('Root has not been mounted');
            }
            root.unmount();
        },
        async update(props) {
            if (!root) {
                throw new Error('Root has not been mounted');
            }
            root.render(createElement(component, { ...props }));
        },
        async hydrate(mfId, instanceId) {
            try {
                const { container, props } = getPrerenderData(mfId, instanceId);
                // @ts-expect-error - React 17 and 18 have different exports
                root = ReactDOM.hydrateRoot(container, createElement(component, props));
            }
            catch {
                // eslint-disable-next-line no-console
                console.warn(`Hydration error '${mfId}:${instanceId}': invalid render data.`);
            }
        },
    };
}
function createReact17Microfrontend(component) {
    return {
        async mount(props, element) {
            return new Promise(resolve => {
                ReactDOM.render(createElement(component, { ...props }), element, resolve);
            });
        },
        async unmount(element) {
            ReactDOM.unmountComponentAtNode(element);
        },
        async update(props, element) {
            return new Promise(resolve => {
                ReactDOM.render(createElement(component, { ...props }), element, resolve);
            });
        },
        async hydrate(mfId, instanceId) {
            try {
                const { container, props } = getPrerenderData(mfId, instanceId);
                return new Promise(resolve => {
                    ReactDOM.hydrate(createElement(component, props), container, resolve);
                });
            }
            catch {
                // eslint-disable-next-line no-console
                console.warn(`Hydration error '${mfId}:${instanceId}': invalid render data.`);
            }
        },
    };
}
function getPrerenderData(mfId, instanceId) {
    const container = new PlaceholderElement(mfId, instanceId).query();
    const propsData = new PropsData(mfId, instanceId).query();
    if (!container || !propsData) {
        // eslint-disable-next-line no-console
        throw new Error(`Prerender data is missing`);
    }
    const props = JSON.parse(propsData.text) || {};
    return {
        container,
        props,
    };
}
//# sourceMappingURL=react-microfrontend.js.map